export const TO_MANY_REQUESTS_STATUS = 429
export const FRONTEND_ERROR = 400
export const TOO_EARLY = 425
